import sanitizeReturnTo from '~/utils/auth/sanitizeReturnTo'

export const useAuthLogin = () => {
  const route = useRoute()

  const handleLogin = async () => {
    const targetPath =
      typeof route.query.returnTo === 'string'
        ? route.query.returnTo
        : route.fullPath

    // Note: post-login to check user roles and redirect to no-stores login URL if necessary
    const postLogin = `/auth/post-login?targetDestination=${encodeURIComponent(sanitizeReturnTo(targetPath))}`

    await navigateTo(`/auth/login?returnTo=${encodeURIComponent(postLogin)}`, {
      external: true,
    })
  }

  return {
    handleLogin,
  }
}
